module.exports = __webpack_public_path__ + "like.2f9zYe0k.svg";